import * as React from 'react';
import { connect } from 'react-redux';

import WorkflowStep from '../../WorkflowStep';
import Fieldset from '../../../components/forms/Fieldset';
import OtherQuestions from './basicQuestions/OtherQuestions';
import Covid19Questions from './basicQuestions/Covid19Questions';
import HeightQuestion from './basicQuestions/HeightQuestion';
import WeightQuestion from './basicQuestions/WeightQuestion';
import userActions from '../../../user/userActions';
import policyActions from '../../../policy/policyActions';
import settingsActions from '../../../common/settingsActions';
import { bindActionCreators } from 'redux';

interface Props {
	user: UserDetails;
	questionnaire: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (e: any) => void;
	onQuestionnaireNumberKeyUp: (e: any) => void;
	onQuestionnaireHeightWeightBlur: (e: any) => void;
	onQuestionnairePaste: (e: any) => void;
	parentNext: (e: any) => void;
	parentPrev: (e: any) => void;
	history: any;
	className?: string;
	actions: any;
	questions: any;
	customerPolicy: CustomerPolicy;
	isHardDeclined: DeclineCheckerDto;
	isSoftDeclined: DeclineCheckerDto;
}
class BasicsForm extends React.Component<Props, any> {
	lastStep = 4;
	constructor(props: Props) {
		super(props);
		this.state = {
			currentStep: this.getStep()
		};
	}
	getStep() {
		var step = parseInt(location.hash.replace('#', ''), 10);
		if (!isNaN(step)) {
			return step;
		}
		return 1;
	}
	componentDidUpdate(prevProps: Props, prevState: any) {
		if (this.state.currentStep !== prevState.currentStep) {
			location.hash = this.state.currentStep.toString();
		}
	}
	prevStep = (e: any) => {
		let currentStep = this.state.currentStep;
		if (currentStep <= 1) {
			this.props.parentPrev(e);
			return;
		} else {
			currentStep--;
			this.setState({ ...this.state, currentStep: currentStep });
		}
	}
	nextStep = (e: any) => {
		let currentStep = this.state.currentStep;
		if (currentStep === this.lastStep) {
			this.props.parentNext(e);
			return;
		} else {
			currentStep++;
			this.setState({ ...this.state, currentStep: currentStep });
		}
	}
	nextStepOtherQuestions = (e: any) => {
		let currentStep = this.state.currentStep;
		if (currentStep === 1 || currentStep === 2) {
			this.props.actions.setQuestionnaireNavigationEnabled(false);
			this.forceOtherQuestionsSave()
			.then(() => this.props.actions.fetchIsHardDeclined(this.props.user.id, this.props.customerPolicy.id))
			.then(() => {
				if (this.props.isHardDeclined.isDeclined) {
					this.props.actions.sendSoftDeclinedEmail(this.props.user.id);
					return this.props.history.push(`/quote/declined`);
				} 
				else {
					const { saveCustomerPolicyAnswer } = this.props.actions;
					const { questionnaire } = this.props;
					const policyId = this.props.customerPolicy.id;
					// Save the default questionnaire values first, otherwise they won't be saved unless user changes them.
					const p1 = saveCustomerPolicyAnswer(policyId, 'heightUnit', questionnaire.heightUnit);
					const p2 = saveCustomerPolicyAnswer(policyId, 'weightUnit', questionnaire.weightUnit);
					Promise.all([p1, p2])
					.then(() => this.nextStep(e));
				}
			})
			.then(() => this.props.actions.setQuestionnaireNavigationEnabled(true));
		} 
		else {
			this.nextStep(e);
		}
	}

	forceOtherQuestionsSave = () => {
		const { saveCustomerPolicyAnswer } = this.props.actions;
		const { questionnaire } = this.props;
		const policyId = this.props.customerPolicy.id;
		let promises: Array<any> = [];
		promises.push(saveCustomerPolicyAnswer(policyId, 'isCanadian', questionnaire.isCanadian));
		if (questionnaire.isCanadian === 'true') {
			promises.push(saveCustomerPolicyAnswer(policyId, 'resideProvince', questionnaire.resideProvince));
		}
		promises.push(saveCustomerPolicyAnswer(policyId, 'hasBeenCancelled', questionnaire.hasBeenCancelled));
		promises.push(saveCustomerPolicyAnswer(policyId, 'pendingCoverage', questionnaire.pendingCoverage));

		if (questionnaire.pendingCoverage === 'true') {
			promises.push(saveCustomerPolicyAnswer(policyId, 'forcedCoverageAmount', questionnaire.forcedCoverageAmount));
			promises.push(saveCustomerPolicyAnswer(policyId, 'pendingCoverageAmount', questionnaire.pendingCoverageAmount));
			promises.push(saveCustomerPolicyAnswer(policyId, 'pendingCoverageReplace', questionnaire.pendingCoverageReplace));
		}

		return Promise.all(promises);
	}

	render() {
		const { questionnaire,
			onQuestionnaireBlur,
			onQuestionnaireChange,
			onQuestionnaireNumberKeyUp,
			onQuestionnaireHeightWeightBlur,
			onQuestionnairePaste,
			user
		} = this.props;
		let currentQuestion = null;
		switch (this.state.currentStep) {
			case 1:
				currentQuestion =
					(
						<OtherQuestions
							questionnaire={questionnaire}
							onQuestionnaireBlur={onQuestionnaireBlur}
							onQuestionnaireChange={onQuestionnaireChange}
							onQuestionnaireNumberKeyUp={onQuestionnaireNumberKeyUp}
							onQuestionnairePaste={onQuestionnairePaste}
							nextStep={this.nextStepOtherQuestions}
							prevStep={this.prevStep}
							questions={this.props.questions}
						/>);
				break;
			case 2:
				currentQuestion =
					(
						<Covid19Questions
							questionnaire={questionnaire}
							onQuestionnaireBlur={onQuestionnaireBlur}
							onQuestionnaireChange={onQuestionnaireChange}
							onQuestionnaireNumberKeyUp={onQuestionnaireNumberKeyUp}
							onQuestionnairePaste={onQuestionnairePaste}
							nextStep={this.nextStepOtherQuestions}
							prevStep={this.prevStep}
							questions={this.props.questions}
						/>
					);
				break;
			case 3:
				currentQuestion = (
					<HeightQuestion
						user={user}
						questionnaire={questionnaire}
						questions={this.props.questions}
						onQuestionnaireBlur={onQuestionnaireBlur}
						onQuestionnaireChange={onQuestionnaireChange}
						nextStep={this.nextStep}
						prevStep={this.prevStep}
						onQuestionnaireHeightWeightBlur={onQuestionnaireHeightWeightBlur}
					/>);
				break;
			case 4:
				currentQuestion = (
					<WeightQuestion
						user={user}
						questionnaire={questionnaire}
						questions={this.props.questions}
						onQuestionnaireBlur={onQuestionnaireBlur}
						onQuestionnaireChange={onQuestionnaireChange}
						nextStep={this.nextStep}
						prevStep={this.prevStep}
						onQuestionnaireHeightWeightBlur={onQuestionnaireHeightWeightBlur}
					/>);
				break;
			default: 
				currentQuestion = <div />;
				break;
		}

		return (
			<WorkflowStep
				className={this.props.className}
				title={this.state.currentStep === 1 ? 'Great! Let\'s get started. First, the basics…' : ''}
			>
				<Fieldset>
					{currentQuestion}
				</Fieldset>
			</WorkflowStep>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		questions: state.question.questions,
		customerPolicy: state.policy.customerPolicy,
		isHardDeclined: state.policy.isHardDeclined,
		isSoftDeclined: state.policy.isSoftDeclined,
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...policyActions, ...settingsActions, ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(BasicsForm);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/BasicsForm.tsx